import React, { useEffect, useRef, useState } from 'react';
import locations from './locationsData';

const RestaurantMap = () => {
  const mapRef = useRef(null);
  const [mapReady, setMapReady] = useState(false);

 

  useEffect(() => {
    const handleGoogleMapsReady = () => {
      console.log('✅ google-maps-ready event received');
      setMapReady(true);
    };

    if (window.google?.maps) {
      handleGoogleMapsReady();
    } else {
      document.addEventListener('google-maps-ready', handleGoogleMapsReady);
      return () => {
        document.removeEventListener('google-maps-ready', handleGoogleMapsReady);
      };
    }
  }, []);

  useEffect(() => {
    if (!mapReady || !mapRef.current) return;

    const map = new window.google.maps.Map(mapRef.current, {
      styles: [
        { elementType: 'geometry', stylers: [{ color: '#f5f5f5' }] },
        { elementType: 'labels.icon', stylers: [{ visibility: 'off' }] },
        { elementType: 'labels.text.fill', stylers: [{ color: '#616161' }] },
        { elementType: 'labels.text.stroke', stylers: [{ color: '#f5f5f5' }] },
        { featureType: 'poi', stylers: [{ visibility: 'off' }] },
        { featureType: 'road', stylers: [{ color: '#b8b8b8ff' }] },
        { featureType: 'transit', stylers: [{ visibility: 'off' }] },
        { featureType: 'water', stylers: [{ color: '#c9c9c9' }] },
        { 
          featureType: 'road.local', 
          elementType: 'labels.text.fill', 
          stylers: [{ visibility: 'on' }, { color: '#616161' }] 
        },
        { 
          featureType: 'road.local', 
          elementType: 'labels.text.stroke', 
          stylers: [{ visibility: 'on' }, { color: '#f5f5f5' }] 
        },
      ],
    });

    if (locations.length === 1) {
      const { lat, lng } = locations[0];
      map.setCenter({ lat, lng });
      map.setZoom(13); // Adjust this number to zoom out/in more
    } else {
      const bounds = new window.google.maps.LatLngBounds();
      locations.forEach(({ lat, lng }) => {
        bounds.extend(new window.google.maps.LatLng(lat, lng));
      });
      map.fitBounds(bounds, { padding: 80 });
    }

    locations.forEach(({ label, lat, lng, orderLink }) => {
      const marker = new window.google.maps.Marker({
        position: { lat, lng },
        map,
        label: {
          text: label,
          color: '#000',
          fontFamily: "venice-blvd",
          fontWeight: 'bold',
          fontSize: '14px',
        },
        title: label,
      });

      marker.addListener('click', () => {
        // window.location.href = orderLink;
      });
    });

  }, [mapReady]);

  return (
    <div style={{ width: '100%', height: '500px' }}>
      {mapReady ? (
        <div ref={mapRef} style={{ width: '100%', height: '100%', borderRadius: '16px' }} />
      ) : (
        <div style={{ width: '100%', height: '100%', background: '#eee', textAlign: 'center', paddingTop: '200px' }}>
          Loading map...
        </div>
      )}
    </div>
  );
};

export default RestaurantMap;